import React, {Component} from 'react';
import { withRouter} from 'react-router-dom';

import {NavControl} from 'modules/navigation/NavBarContainer.js';
import Challenge from 'modules/challenges/Challenge.js';

const onCloseChallenge = () => {
    
}

class ChallengeLoaderContainer extends Component {
    constructor(props) {
        super(props);
        this.onCloseChallenge = this.onCloseChallenge.bind(this);
    }

    onCloseChallenge() {
        this.props.history.push('/home');
    }
    
    render() {
        return (
            <NavControl key="challengeloader" onClose={this.onCloseChallenge}>
                <Challenge challengeId={this.props.match.params.id} />
            </NavControl>
        );
    }
}

export default withRouter(ChallengeLoaderContainer);



// WEBPACK FOOTER //
// ./src/modules/challenges/ChallengeLoaderContainer.js